/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A Device Reading
 */
export type Reading = {
	/**
	 * The reading value
	 */
	readingValue?: string;
	/**
	 * The unit of measure for the device
	 */
	unitOfMeasure?: Reading.unitOfMeasure;
};
export namespace Reading {
	/**
	 * The unit of measure for the device
	 */
	export enum unitOfMeasure {
		ML = 'ML',
		L = 'L',
		KL = 'KL',
		M3 = 'm3',
		X10M3 = 'x10m3',
		X100M3 = 'x100m3',
	}
}
